module.exports = __webpack_public_path__ + "img/34497-007.92720984.jpg";